import React, { createContext, useContext, useState } from 'react';
import { RootState } from 'store/ducks';
import { useSelector } from 'react-redux';
//interfaces
import { FiltersHeaderContextProviderProps, FiltersHeaderContextType } from './interface';

export const FiltersHeaderContext = createContext({} as FiltersHeaderContextType);

export function FiltersHeaderContextProvider(props: FiltersHeaderContextProviderProps) {
  const { children } = props;

  const globalFilter = useSelector((stateFilter: RootState) => stateFilter.quotesDashboard);
  const [loadingSecondRender, setLoadingSecondRender] = useState<boolean>(false);
  const [error, setError] = useState({ enable: false, message: "" });
  const [dateFilterON, setDateFilterON] = useState<boolean>(false);
  const [filterText, setFilterText] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(0);
  const [noResults, setNoResults] = useState(false);
  const [tags, setTags] = useState<string[]>([]);

  const selectedSeller = globalFilter?.sellerId;
  const selectedSubsidiary = globalFilter?.subsidiary;
  const selectedCategories = globalFilter?.productCategories;
  const selectedOrigin = globalFilter?.origin;

  return (
    <FiltersHeaderContext.Provider value={{
      tags,
      error,
      setTags,
      setError,
      noResults,
      filterText,
      currentPage,
      dateFilterON,
      setNoResults,
      setFilterText,
      selectedSeller,
      setCurrentPage,
      setDateFilterON,
      selectedCategories,
      selectedSubsidiary,
      selectedOrigin,
      loadingSecondRender,

      setLoadingSecondRender
    }}>
      {children}
    </FiltersHeaderContext.Provider>
  );
}

export const useFiltersHeaderContext = () => {
  return useContext(FiltersHeaderContext);
};